const allowedStudentsPageStrings = {
  en: {
    page: {
      title: "Manage Allowed Students",
      description: "Control which students are allowed to book office hours",
    },
  modals: {
    close: "Close",
    addTitle: "Add Allowed Student",
    editTitle: "Edit Allowed Student",
    deleteTitle: "Delete Allowed Student",
    statusTitle: "Booking Policy Settings",
  },
  buttons: {
    add: "Add Student",
    edit: "Edit",
    delete: "Delete",
    refresh: "Refresh",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    back: "Back",
    close: "Close",
  },
  forms: {
    firstName: "First Name",
    lastName: "Last Name",
    idNumber: "ID Number",
    email: "Email Address",
    placeholders: {
      firstName: "Enter first name",
      lastName: "Enter last name",
      idNumber: "Enter student ID",
      email: "Enter email address",
    },
    validation: {
      required: "This field is required",
      invalidEmail: "Invalid email address",
      duplicateEmail: "This email is already allowed",
      duplicateId: "This ID is already allowed",
    },
  },
  table: {
    title: "Allowed Students",
    empty: "No allowed students found",
    headers: {
      firstName: "First Name",
      lastName: "Last Name",
      idNumber: "ID Number",
      email: "Email",
      actions: "Actions",
    },
    studentsFound: "students",
    noResults: "No students match your search",
  },
  search: {
    placeholder: "Search by name, ID, or email...",
    label: "Search",
  },
  sort: {
    label: "Sort by",
    byName: "First Name",
    byEmail: "Email",
    byId: "ID Number",
  },
  status: {
    title: "Booking Policy Settings",
    description: "Configure who can book office hours for this slot",
    allowedOnly: "Only Allowed Students",
    allowedOnlyDesc: "Only students in the list above can book",
    allStudents: "All Students Allowed",
    allStudentsDesc: "Any student can book office hours",
    currentStatus: "Current Status",
    toggle: "Change Setting",
  },
  messages: {
    loading: "Loading...",
    adding: "Adding student...",
    updating: "Updating student...",
    deleting: "Deleting student...",
    success: "Operation completed successfully",
    addSuccess: "Student added successfully",
    editSuccess: "Student updated successfully",
    deleteSuccess: "Student deleted successfully",
    noSlotSelected: "Please select a slot first",
    selectSlot: "Select a slot to view or manage allowed students",
    error: "An error occurred. Please try again.",
    confirmDelete: "Are you sure you want to delete this student?",
    deleteWarning: "This action cannot be undone.",
  },
  slots: {
    title: "Select a Slot",
    selectPlaceholder: "Choose a slot",
    empty: "No slots available",
    noSlots: "Create a slot first to manage allowed students",
  },
  aria: {
    toggleNav: "Toggle navigation",
    openMenu: "Open menu",
    closeMenu: "Close menu",
  },
  },
  ar: {
    page: {
      title: "إدارة الطلاب المسموح لهم",
      description: "التحكم في الطلاب المسموح لهم بحجز الساعات المكتبية",
    },
    modals: {
      close: "إغلاق",
      addTitle: "إضافة طالب مسموح له",
      editTitle: "تعديل طالب مسموح له",
      deleteTitle: "حذف طالب مسموح له",
      statusTitle: "إعدادات سياسة الحجز",
    },
    buttons: {
      add: "إضافة طالب",
      edit: "تعديل",
      delete: "حذف",
      refresh: "تحديث",
      save: "حفظ",
      cancel: "إلغاء",
      confirm: "تأكيد",
      back: "رجوع",
      close: "إغلاق",
    },
    forms: {
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      idNumber: "الرقم الجامعي",
      email: "البريد الإلكتروني",
      placeholders: {
        firstName: "أدخل الاسم الأول",
        lastName: "أدخل اسم العائلة",
        idNumber: "أدخل الرقم الجامعي",
        email: "أدخل البريد الإلكتروني",
      },
      validation: {
        required: "هذا الحقل مطلوب",
        invalidEmail: "البريد الإلكتروني غير صحيح",
        duplicateEmail: "هذا البريد الإلكتروني مسموح له بالفعل",
        duplicateId: "هذا الرقم الجامعي مسموح له بالفعل",
      },
    },
    table: {
      title: "الطلاب المسموح لهم",
      empty: "لا يوجد طلاب مسموح لهم",
      headers: {
        firstName: "الاسم الأول",
        lastName: "اسم العائلة",
        idNumber: "الرقم الجامعي",
        email: "البريد الإلكتروني",
        actions: "الإجراءات",
      },
      studentsFound: "طالب",
      noResults: "لا يوجد طلاب تطابق بحثك",
    },
    search: {
      placeholder: "البحث بالاسم، الرقم الجامعي، أو البريد الإلكتروني...",
      label: "بحث",
    },
    sort: {
      label: "ترتيب حسب",
      byName: "الاسم الأول",
      byEmail: "البريد الإلكتروني",
      byId: "الرقم الجامعي",
    },
    status: {
      title: "إعدادات سياسة الحجز",
      description: "تكوين من يمكنه حجز الساعات المكتبية لهذا الموعد",
      allowedOnly: "الطلاب المسموح لهم فقط",
      allowedOnlyDesc: "فقط الطلاب في القائمة أعلاه يمكنهم الحجز",
      allStudents: "جميع الطلاب مسموح لهم",
      allStudentsDesc: "أي طالب يمكنه حجز الساعات المكتبية",
      currentStatus: "الحالة الحالية",
      toggle: "تغيير الإعداد",
    },
    messages: {
      loading: "جارٍ التحميل...",
      adding: "جارٍ إضافة الطالب...",
      updating: "جارٍ تحديث الطالب...",
      deleting: "جارٍ حذف الطالب...",
      success: "تمت العملية بنجاح",
      addSuccess: "تمت إضافة الطالب بنجاح",
      editSuccess: "تم تحديث الطالب بنجاح",
      deleteSuccess: "تم حذف الطالب بنجاح",
      noSlotSelected: "يرجى اختيار موعد أولاً",
      selectSlot: "اختر موعداً لعرض أو إدارة الطلاب المسموح لهم",
      error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      confirmDelete: "هل أنت متأكد من حذف هذا الطالب؟",
      deleteWarning: "لا يمكن التراجع عن هذا الإجراء.",
    },
    slots: {
      title: "اختر موعداً",
      selectPlaceholder: "اختر موعداً",
      empty: "لا توجد مواعيد متاحة",
      noSlots: "قم بإنشاء موعد أولاً لإدارة الطلاب المسموح لهم",
    },
    aria: {
      toggleNav: "تبديل التنقل",
      openMenu: "فتح القائمة",
      closeMenu: "إغلاق القائمة",
    },
  },
};

export default allowedStudentsPageStrings;
